import type { CSSObject } from "@mui/material/styles";
import type { StateSpec } from "./StateSpec";

export const stateToCss = (spec: StateSpec): CSSObject => {
  const out: CSSObject = {};
  if (spec.backgroundColor) out.backgroundColor = spec.backgroundColor;
  if (spec.color === "inherit") out.color = "inherit";
  else if (spec.color) out.color = spec.color;
  if (spec.borderColor) out.borderColor = spec.borderColor;
  if (spec.ring) out.boxShadow = spec.ring;
  if (spec.elevation) out.boxShadow = spec.elevation;
  if (spec.opacity !== undefined) out.opacity = spec.opacity;
  if (spec.textDecorationColor) {
    out.textDecorationLine = "underline";
    out.textDecorationColor = spec.textDecorationColor;
  }
  return out;
};
